import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import API from "../utils/API";

import VillageWorld from "../features/world/VillageWorld";

function VillageGame() {
  const { id } = useParams();
  const [userAvatar, setUserAvatar] = useState(null);
  const [userAvatarName, setUserAvatarName] = useState(null);

  useEffect(() => {
    const getUserData = async () => {
      const userData = await API.getUser(id);
      const user = await userData.json();
      const { sprite, name } = user.sprite[0];
      setUserAvatar(sprite);
      setUserAvatarName(name);
    };
    getUserData();
  }, [id]);

  return (
    <div>
      <VillageWorld
        avatar={userAvatar}
        avatarName={userAvatarName}
      />

    </div>
  );
}

export default VillageGame;
